import InputField from "components/fields/InputField";
import { FcGoogle } from "react-icons/fc";
import Checkbox from "components/checkbox";
import { useState } from "react";
import { loginValidation } from "utils/validation";
import { isYupError } from "utils/Yup";
import { parseYupError } from "utils/Yup";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ToastMsg from "components/toast/ToastMsg";
import { BeatLoader } from "react-spinners";
import Cookies from "js-cookie";
import { postApiReq } from "utils/ApiHandlers";
import { FiEye, FiEyeOff } from "react-icons/fi";
import useAuth from "utils/useAuth";
import axios from "axios";

export default function SignIn() {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [tempToken, setTempToken] = useState('');
  const [code, setCode] = useState();
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [qrDetail, setQrDetail] = useState();
  const [showQr, setShowQr] = useState(false)
  const toggleVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value.trim() });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const { generateQr } = useAuth();

  const navigate = useNavigate();
  const handleVerify2FA = async (code) => {
    console.log('🔐 handleVerify2FA called');
    console.log('📌 showQr:', showQr);
    console.log('📌 code entered:', code);

    try {
      // Case 1: QR flow (first-time 2FA setup)
      if (showQr) {
        console.log('🟡 QR flow detected → verifying 2FA setup');

        console.log('➡️ Calling /auth/2fa/generate with code');
        const verifyRes = await axios.post(
          'https://api.payfirewallcrypto.com/auth/2fa/verify',
          { code },
          {
            headers: {
              Authorization: `Bearer ${tempToken}`,
            },
            withCredentials: true,
          }
        );

        console.log('📥 /auth/2fa/generate response:', verifyRes);
        console.log('📥 response.data:', verifyRes.data);
        console.log('📥 response.status:', verifyRes.status);

        if (verifyRes.status === 200 || verifyRes.status === 201) {
          console.log('✅ 2FA setup verification successful');
          console.log('➡️ Proceeding to login verification');

          handleVerify2FAlogin(code);
        } else {
          console.warn('⚠️ Unexpected status from 2FA generate:', verifyRes.status);
        }
      }
      // Case 2: Normal 2FA login 
      else {
        console.log('🟢 Existing 2FA → direct login verification');
        handleVerify2FAlogin(code);
      }
    } catch (error) {
      console.error(
        '❌ Error in handleVerify2FA:',
        error,
        'response:',
        error?.response?.data,
        'status:',
        error?.response?.status
      );
    }
  };

  const handleVerify2FAlogin = async (code) => {
    console.log("🔑 Verifying 2FA with code:", code);
    setIsLoading(true);
    try {
      console.log("📦 Payload for /auth/2fa/login:", { tempToken, code });

      // 2️⃣ Call /auth/2fa/login with tempToken & code in body
      const loginRes = await axios.post(
        "https://api.payfirewallcrypto.com/auth/2fa/login",
        { tempToken, code },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true, // just in case cookies are used server-side
        }
      );

      console.log("📥 /auth/2fa/login response object:", loginRes);
      console.log("✅ /auth/2fa/login response data:", loginRes.data);

      if (loginRes.data?.accessToken) {
        // Optionally store token and navigate
        Cookies.set(
          "user",
          JSON.stringify({
            token: loginRes.data.accessToken,
          })
        );
        Cookies.set(
          "__admin__isLoggedIn",
          JSON.stringify({
            token: loginRes.data.accessToken,
          })
        );
        localStorage.setItem("userLoginType", loginRes?.data?.type);
        console.log("🚀 Login successful, redirecting...");
        toast.success(<ToastMsg title="Login Successfully" />);
        navigate("/admin/default");
      } else {
        console.warn("⚠️ Login response missing accessToken:", loginRes.data);
        toast.error("Login failed: accessToken missing");
      }
    } catch (error) {
      console.error(
        "❌ Error in 2FA verification/login:",
        error,
        "response data:",
        error?.response?.data,
        "status:",
        error?.response?.status
      );
      toast.error(error?.response?.data?.message || "2FA verification failed");
    } finally {
      setIsLoading(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("➡️ handleSubmit triggered");

    setIsLoading(true);
    try {
      setErrors({});
      console.log("📌 Validating form:", form);

      await loginValidation.validate(form, {
        abortEarly: false,
      });
      console.log("✅ Form validation passed");

      postApiReq("/auth/login", form)
        .then(async (res) => {
          console.log(res, "res")
          if (!res?.status) {
            toast.dismiss();
            toast.error(res?.error?.message || "Login failed");
            setIsLoading(false);
            return;
          }
          setTempToken(res.data.tempToken);
          if (res.status) {
            setIsLoading(false);



            // --- 2FA Check & QR Generation ---
            if (!res?.data?.isTwoFaGenerated) {
              console.log("🔐 2FA required!");
              setOpen(true);
              setTempToken(res.data.tempToken);
              console.log("🟢 tempToken set:", res.data.tempToken);

              try {
                console.log("🟡 Generating QR code...");
                const qrRes = await generateQr(res.data.tempToken);
                console.log("📥 generateQr response:", qrRes);

                if (qrRes) {
                  setQrDetail(qrRes.data);
                  setShowQr(true);
                  console.log(showQr, "showQr")
                  console.log("✅ QR details set, showQr=true");
                }
              } catch (qrError) {
                console.error("❌ QR Generation failed:", qrError);
                toast.error("Failed to generate 2FA QR code");
              }
            } else {
              console.log("ℹ️ No 2FA required, navigating to admin");
              setOpen(true);
            }
          } else {
            setIsLoading(false);
            console.warn("⚠️ Login failed:", res?.error?.message);
            toast.error(<ToastMsg title={res?.error?.message} />);
          }

        })
        .catch((e) => {

          setIsLoading(false);
          console.error("❌ /auth/login API error:", e);
        });
    } catch (error) {

      setIsLoading(false);
      console.error("❌ Validation error:", error);
      if (isYupError(error)) {
        const parsedErrors = parseYupError(error);
        console.log("📌 Parsed validation errors:", parsedErrors);
        setErrors(parsedErrors);
      }
    } finally {
      console.log("⏹️ handleSubmit finished");
    }
  };


  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">

      <div>

        {/* Sign in section */}
        <form
          onSubmit={handleSubmit}
          className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]"
        >
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
            Welcome
          </h4>
          <p className="mb-9 ml-1 text-base text-gray-600">
            Enter your email and password to sign in!
          </p>
          {/* Email */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Email*"
            placeholder="Enter your email"
            id="email"
            name="email"
            type="text"
            value={form.email}
            onChange={handleChange}
            state={errors.email ? "error" : "success"}
            error={errors.email}
          />

          <div className=" ">
            <div className="relative">
              <InputField
                variant="auth"
                extra="mb-3"
                label="Password*"
                placeholder="Min. 8 characters"
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={form.password}
                state={errors.password ? "error" : "success"}
                onChange={handleChange}
                error={errors.password}
              />
              <span
                // type="button"
                onClick={toggleVisibility}
                className="bg-transparent absolute  right-3 top-14 -translate-y-1/2"
              >
                {showPassword ? (
                  <FiEye className="btn-blu" />
                ) : (
                  <FiEyeOff className="btn-blu" />
                )}
              </span>
            </div>
          </div>
          {/* Checkbox */}
          {/* <div className="mb-4 flex items-center justify-between px-2">
            <div className="flex items-center">
              <Checkbox name="consent" />
              <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
                Keep me logged In
              </p>
            </div>
  
            <a
              className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
              href=" "
            >
              Forgot Password?
            </a>
          </div> */}
          <button
            type="submit"
            disabled={isLoading}
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {isLoading ? <BeatLoader color="#ffffff" className="" /> : " Log In"}
          </button>
          {/* <div className="mt-4">
            <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
              Not registered yet?
            </span>
            <a
              href=" "
              className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            >
              Create an account
            </a>
          </div> */}
          {open && (
            <div className="mt-6 rounded-xl border p-4">
              {showQr && qrDetail?.qrCode && (
                <div className="flex flex-col items-center gap-3">
                  <img
                    src={qrDetail.qrCode}
                    alt="2FA QR"
                    className="h-40 w-40"
                  />
                  <p className="text-sm text-gray-600">
                    Scan this QR in Google Authenticator
                  </p>
                </div>
              )}

              <InputField
                variant="auth"
                label="Enter 6-digit code"
                placeholder="123456"
                type="text"
                value={code || ""}
                onChange={(e) => setCode(e.target.value)}
                extra="mt-4"
              />

              <button
                type="button"
                disabled={isLoading || !code || code.length !== 6}
                onClick={() => handleVerify2FA(code)}
                className="linear mt-3 w-full rounded-xl bg-brand-500 py-[10px] text-white"
              >
                {isLoading ? <BeatLoader color="#fff" /> : "Verify & Login"}
              </button>
            </div>
          )}

        </form>
      </div>
    </div>
  );
}
